// Landing page copy per language. Keys are flat strings; `features` is an ordered list of 9 cards.
const landing = {
  pt: {
    navLogin: 'Entrar',
    navStart: 'Começar',
    heroTag: 'Treinamento inteligente com IA',
    heroTitle: 'TRANSFORMA O TEU',
    heroTitleHighlight: 'CORPO',
    heroSubtitle: 'Planos personalizados criados por inteligência artificial. Integração com o Strava e otimiza os teus resultados.',
    heroCta: 'Criar o Meu Plano',
    heroHasAccount: 'Já tenho conta',
    featTag: 'Porquê fazer treinos pelo Process Body AI?',
    featTitle: 'TER CORPO',
    featTitleHighlight: 'INTELIGENTE',
    featSubtitle: 'Melhor versão de ti, emagrecer, corpo fit, ter mobilidade, melhorar aspetos de saúde, ter independência a treinar',
    features: [
      { title: 'IA Avançada', description: 'Planos criados por Claude Sonnet 4.5, considerando todos os teus dados e histórico' },
      { title: 'Assistente IA', description: 'Chatbot, Coach Virtual e ajuste de planos com 3 níveis de assinatura' },
      { title: 'Integração Strava', description: 'Liga a tua conta Strava e tem planos baseados nas tuas atividades reais' },
      { title: 'Timer Integrado', description: 'Timer para intervalados com presets de HIIT, Tabata e personalizados' },
      { title: 'Exportar PDF', description: 'Exporta os teus planos em PDF para treinar offline ou partilhar' },
      { title: '10+ Tipos de Cardio', description: 'Corrida, ciclismo, natação, remo, HIIT, saltar à corda e muito mais' },
      { title: 'Progressão', description: 'Acompanha a tua evolução semana a semana com gráficos detalhados' },
      { title: 'Personalizado', description: 'Adaptado ao teu nível, lesões, restrições e objetivos específicos' },
      { title: 'Multimodalidade', description: 'Combina diferentes tipos de cardio num único plano integrado' }
    ],
    aboutTag: 'Quem Somos Nós?',
    aboutTitle: 'A TUA EQUIPA DE',
    aboutTitleHighlight: 'SUCESSO',
    aboutP1: 'Somos uma equipa apaixonada por fitness e tecnologia, e que quer ajudar o próximo — que podes ser tu. Combinamos anos de experiência em treino personalizado com inteligência artificial de ponta para criar a melhor experiência de treino possível.',
    aboutP2: 'A nossa missão é democratizar o acesso a treinos de qualidade, tornando o personal training acessível a todos. Queremos dar qualidade de vida a todas as pessoas e chegar a todo o lado pelo mundo fora.',
    yearsExp: 'Anos de Experiência',
    statUsers: 'Utilizadores',
    statPlans: 'Planos Criados',
    statSatisfaction: 'Satisfação',
    instagramFollow: 'Segue-nos @process_body_pt',
    ctaTitle: 'Pronto para',
    ctaTitleHighlight: 'começar',
    ctaSubtitle: 'Cria a tua conta gratuita e recebe o teu primeiro plano de treino personalizado em segundos.',
    ctaBtn: 'Começar Agora',
    footerTagline: 'Personal Trainer com IA.'
  },

  en: {
    navLogin: 'Log in',
    navStart: 'Get started',
    heroTag: 'Smart AI-powered training',
    heroTitle: 'TRANSFORM YOUR',
    heroTitleHighlight: 'BODY',
    heroSubtitle: 'Personalised plans created by artificial intelligence. Connect Strava and optimise your results.',
    heroCta: 'Create My Plan',
    heroHasAccount: 'I already have an account',
    featTag: 'Why train with Process Body AI?',
    featTitle: 'TRAIN',
    featTitleHighlight: 'SMARTER',
    featSubtitle: 'A better version of you: lose weight, get fit, improve mobility and health, and train with full independence',
    features: [
      { title: 'Advanced AI', description: 'Plans built by Claude Sonnet 4.5 using all your data and training history' },
      { title: 'AI Assistant', description: 'Chatbot, Virtual Coach and plan adjustments across 3 subscription tiers' },
      { title: 'Strava Integration', description: 'Connect your Strava account and get plans based on your real activities' },
      { title: 'Built-in Timer', description: 'Interval timer with HIIT, Tabata and custom presets' },
      { title: 'PDF Export', description: 'Export your plans to PDF to train offline or share them' },
      { title: '10+ Cardio Types', description: 'Running, cycling, swimming, rowing, HIIT, jump rope and much more' },
      { title: 'Progress Tracking', description: 'Follow your evolution week by week with detailed charts' },
      { title: 'Personalised', description: 'Adapted to your level, injuries, restrictions and specific goals' },
      { title: 'Multi-modality', description: 'Combine different cardio types in a single integrated plan' }
    ],
    aboutTag: 'Who We Are',
    aboutTitle: 'YOUR TEAM FOR',
    aboutTitleHighlight: 'SUCCESS',
    aboutP1: 'We are a team passionate about fitness and technology, here to help the person next to us — and that can be you. We combine years of personal training experience with cutting-edge artificial intelligence to build the best training experience possible.',
    aboutP2: 'Our mission is to democratise access to quality training and make personal training affordable for everyone. We want to bring quality of life to people everywhere in the world.',
    yearsExp: 'Years of Experience',
    statUsers: 'Users',
    statPlans: 'Plans Created',
    statSatisfaction: 'Satisfaction',
    instagramFollow: 'Follow us @process_body_pt',
    ctaTitle: 'Ready to',
    ctaTitleHighlight: 'start',
    ctaSubtitle: 'Create your free account and get your first personalised workout plan in seconds.',
    ctaBtn: 'Start Now',
    footerTagline: 'AI-powered Personal Trainer.'
  },

  es: {
    navLogin: 'Entrar',
    navStart: 'Empezar',
    heroTag: 'Entrenamiento inteligente con IA',
    heroTitle: 'TRANSFORMA TU',
    heroTitleHighlight: 'CUERPO',
    heroSubtitle: 'Planes personalizados creados por inteligencia artificial. Conecta Strava y optimiza tus resultados.',
    heroCta: 'Crear Mi Plan',
    heroHasAccount: 'Ya tengo cuenta',
    featTag: '¿Por qué entrenar con Process Body AI?',
    featTitle: 'ENTRENA CON',
    featTitleHighlight: 'INTELIGENCIA',
    featSubtitle: 'Tu mejor versión: adelgazar, ponerte en forma, mejorar la movilidad y la salud, y entrenar con independencia',
    features: [
      { title: 'IA Avanzada', description: 'Planes creados por Claude Sonnet 4.5 con todos tus datos e historial' },
      { title: 'Asistente IA', description: 'Chatbot, Coach Virtual y ajuste de planes con 3 niveles de suscripción' },
      { title: 'Integración Strava', description: 'Conecta tu cuenta de Strava y recibe planes según tus actividades reales' },
      { title: 'Temporizador', description: 'Temporizador de intervalos con presets de HIIT, Tabata y personalizados' },
      { title: 'Exportar PDF', description: 'Exporta tus planes en PDF para entrenar sin conexión o compartirlos' },
      { title: '10+ Tipos de Cardio', description: 'Correr, ciclismo, natación, remo, HIIT, saltar la cuerda y mucho más' },
      { title: 'Progresión', description: 'Sigue tu evolución semana a semana con gráficos detallados' },
      { title: 'Personalizado', description: 'Adaptado a tu nivel, lesiones, restricciones y objetivos concretos' },
      { title: 'Multimodalidad', description: 'Combina distintos tipos de cardio en un único plan integrado' }
    ],
    aboutTag: '¿Quiénes Somos?',
    aboutTitle: 'TU EQUIPO DE',
    aboutTitleHighlight: 'ÉXITO',
    aboutP1: 'Somos un equipo apasionado por el fitness y la tecnología que quiere ayudar al prójimo, y ese puedes ser tú. Combinamos años de experiencia en entrenamiento personal con inteligencia artificial de vanguardia para crear la mejor experiencia posible.',
    aboutP2: 'Nuestra misión es democratizar el acceso a entrenamientos de calidad y hacer que el entrenamiento personal sea accesible para todos. Queremos dar calidad de vida a las personas en todo el mundo.',
    yearsExp: 'Años de Experiencia',
    statUsers: 'Usuarios',
    statPlans: 'Planes Creados',
    statSatisfaction: 'Satisfacción',
    instagramFollow: 'Síguenos @process_body_pt',
    ctaTitle: '¿Listo para',
    ctaTitleHighlight: 'empezar',
    ctaSubtitle: 'Crea tu cuenta gratuita y recibe tu primer plan de entrenamiento personalizado en segundos.',
    ctaBtn: 'Empezar Ahora',
    footerTagline: 'Entrenador Personal con IA.'
  },

  fr: {
    navLogin: 'Connexion',
    navStart: 'Commencer',
    heroTag: 'Entraînement intelligent avec IA',
    heroTitle: 'TRANSFORME TON',
    heroTitleHighlight: 'CORPS',
    heroSubtitle: 'Des plans personnalisés créés par intelligence artificielle. Connecte Strava et optimise tes résultats.',
    heroCta: 'Créer Mon Plan',
    heroHasAccount: "J'ai déjà un compte",
    featTag: 'Pourquoi s’entraîner avec Process Body AI ?',
    featTitle: 'ENTRAÎNE-TOI',
    featTitleHighlight: 'INTELLIGEMMENT',
    featSubtitle: 'Ta meilleure version : perdre du poids, être en forme, gagner en mobilité et en santé, et t’entraîner en autonomie',
    features: [
      { title: 'IA Avancée', description: 'Plans créés par Claude Sonnet 4.5 avec toutes tes données et ton historique' },
      { title: 'Assistant IA', description: 'Chatbot, Coach Virtuel et ajustement des plans sur 3 niveaux d’abonnement' },
      { title: 'Intégration Strava', description: 'Connecte ton compte Strava et obtiens des plans basés sur tes activités réelles' },
      { title: 'Minuteur Intégré', description: 'Minuteur d’intervalles avec préréglages HIIT, Tabata et personnalisés' },
      { title: 'Export PDF', description: 'Exporte tes plans en PDF pour t’entraîner hors ligne ou les partager' },
      { title: '10+ Types de Cardio', description: 'Course, vélo, natation, rameur, HIIT, corde à sauter et bien plus' },
      { title: 'Progression', description: 'Suis ton évolution semaine après semaine avec des graphiques détaillés' },
      { title: 'Personnalisé', description: 'Adapté à ton niveau, tes blessures, tes restrictions et tes objectifs' },
      { title: 'Multi-modalité', description: 'Combine différents types de cardio dans un seul plan intégré' }
    ],
    aboutTag: 'Qui Sommes-Nous ?',
    aboutTitle: 'TON ÉQUIPE DE',
    aboutTitleHighlight: 'SUCCÈS',
    aboutP1: 'Nous sommes une équipe passionnée de fitness et de technologie, qui veut aider son prochain — et ce prochain, c’est toi. Nous combinons des années d’expérience en coaching personnel avec une intelligence artificielle de pointe.',
    aboutP2: 'Notre mission est de démocratiser l’accès à un entraînement de qualité et de rendre le coaching personnel accessible à tous, partout dans le monde.',
    yearsExp: 'Ans d’Expérience',
    statUsers: 'Utilisateurs',
    statPlans: 'Plans Créés',
    statSatisfaction: 'Satisfaction',
    instagramFollow: 'Suis-nous @process_body_pt',
    ctaTitle: 'Prêt à',
    ctaTitleHighlight: 'commencer',
    ctaSubtitle: 'Crée ton compte gratuit et reçois ton premier plan d’entraînement personnalisé en quelques secondes.',
    ctaBtn: 'Commencer',
    footerTagline: 'Coach Personnel avec IA.'
  },

  de: {
    navLogin: 'Anmelden',
    navStart: 'Loslegen',
    heroTag: 'Intelligentes Training mit KI',
    heroTitle: 'VERÄNDERE DEINEN',
    heroTitleHighlight: 'KÖRPER',
    heroSubtitle: 'Personalisierte Pläne, erstellt von künstlicher Intelligenz. Verbinde Strava und optimiere deine Ergebnisse.',
    heroCta: 'Meinen Plan Erstellen',
    heroHasAccount: 'Ich habe schon ein Konto',
    featTag: 'Warum mit Process Body AI trainieren?',
    featTitle: 'TRAINIERE',
    featTitleHighlight: 'INTELLIGENT',
    featSubtitle: 'Deine beste Version: abnehmen, fit werden, Mobilität und Gesundheit verbessern und eigenständig trainieren',
    features: [
      { title: 'Fortschrittliche KI', description: 'Pläne von Claude Sonnet 4.5, auf Basis all deiner Daten und deiner Historie' },
      { title: 'KI-Assistent', description: 'Chatbot, virtueller Coach und Plananpassung in 3 Abo-Stufen' },
      { title: 'Strava-Integration', description: 'Verbinde dein Strava-Konto und erhalte Pläne auf Basis echter Aktivitäten' },
      { title: 'Integrierter Timer', description: 'Intervall-Timer mit HIIT-, Tabata- und eigenen Voreinstellungen' },
      { title: 'PDF-Export', description: 'Exportiere deine Pläne als PDF, um offline zu trainieren oder sie zu teilen' },
      { title: '10+ Cardio-Arten', description: 'Laufen, Radfahren, Schwimmen, Rudern, HIIT, Seilspringen und mehr' },
      { title: 'Fortschritt', description: 'Verfolge deine Entwicklung Woche für Woche mit detaillierten Diagrammen' },
      { title: 'Personalisiert', description: 'Angepasst an dein Niveau, Verletzungen, Einschränkungen und Ziele' },
      { title: 'Multimodal', description: 'Kombiniere verschiedene Cardio-Arten in einem integrierten Plan' }
    ],
    aboutTag: 'Wer Wir Sind',
    aboutTitle: 'DEIN TEAM FÜR',
    aboutTitleHighlight: 'ERFOLG',
    aboutP1: 'Wir sind ein Team mit Leidenschaft für Fitness und Technologie und wollen Menschen helfen — zum Beispiel dir. Wir verbinden jahrelange Erfahrung im Personal Training mit modernster künstlicher Intelligenz.',
    aboutP2: 'Unsere Mission ist es, hochwertiges Training für alle zugänglich zu machen und Menschen überall auf der Welt mehr Lebensqualität zu geben.',
    yearsExp: 'Jahre Erfahrung',
    statUsers: 'Nutzer',
    statPlans: 'Erstellte Pläne',
    statSatisfaction: 'Zufriedenheit',
    instagramFollow: 'Folge uns @process_body_pt',
    ctaTitle: 'Bereit',
    ctaTitleHighlight: 'loszulegen',
    ctaSubtitle: 'Erstelle dein kostenloses Konto und erhalte in Sekunden deinen ersten personalisierten Trainingsplan.',
    ctaBtn: 'Jetzt Starten',
    footerTagline: 'Personal Trainer mit KI.'
  },

  it: {
    navLogin: 'Accedi',
    navStart: 'Inizia',
    heroTag: 'Allenamento intelligente con IA',
    heroTitle: 'TRASFORMA IL TUO',
    heroTitleHighlight: 'CORPO',
    heroSubtitle: 'Piani personalizzati creati dall’intelligenza artificiale. Collega Strava e ottimizza i tuoi risultati.',
    heroCta: 'Crea il Mio Piano',
    heroHasAccount: 'Ho già un account',
    featTag: 'Perché allenarsi con Process Body AI?',
    featTitle: 'ALLENATI IN MODO',
    featTitleHighlight: 'INTELLIGENTE',
    featSubtitle: 'La tua versione migliore: perdere peso, essere in forma, migliorare mobilità e salute e allenarti in autonomia',
    features: [
      { title: 'IA Avanzata', description: 'Piani creati da Claude Sonnet 4.5 con tutti i tuoi dati e lo storico' },
      { title: 'Assistente IA', description: 'Chatbot, Coach Virtuale e modifica dei piani su 3 livelli di abbonamento' },
      { title: 'Integrazione Strava', description: 'Collega il tuo account Strava e ricevi piani basati sulle attività reali' },
      { title: 'Timer Integrato', description: 'Timer a intervalli con preset HIIT, Tabata e personalizzati' },
      { title: 'Esporta PDF', description: 'Esporta i tuoi piani in PDF per allenarti offline o condividerli' },
      { title: '10+ Tipi di Cardio', description: 'Corsa, ciclismo, nuoto, canottaggio, HIIT, salto della corda e molto altro' },
      { title: 'Progressione', description: 'Segui la tua evoluzione settimana per settimana con grafici dettagliati' },
      { title: 'Personalizzato', description: 'Adattato al tuo livello, infortuni, limitazioni e obiettivi specifici' },
      { title: 'Multimodalità', description: 'Combina diversi tipi di cardio in un unico piano integrato' }
    ],
    aboutTag: 'Chi Siamo',
    aboutTitle: 'LA TUA SQUADRA DEL',
    aboutTitleHighlight: 'SUCCESSO',
    aboutP1: 'Siamo un team appassionato di fitness e tecnologia che vuole aiutare le persone — e quella persona puoi essere tu. Uniamo anni di esperienza nel personal training all’intelligenza artificiale più avanzata.',
    aboutP2: 'La nostra missione è rendere accessibile a tutti un allenamento di qualità e portare qualità di vita alle persone in tutto il mondo.',
    yearsExp: 'Anni di Esperienza',
    statUsers: 'Utenti',
    statPlans: 'Piani Creati',
    statSatisfaction: 'Soddisfazione',
    instagramFollow: 'Seguici @process_body_pt',
    ctaTitle: 'Pronto a',
    ctaTitleHighlight: 'iniziare',
    ctaSubtitle: 'Crea il tuo account gratuito e ricevi il primo piano di allenamento personalizzato in pochi secondi.',
    ctaBtn: 'Inizia Ora',
    footerTagline: 'Personal Trainer con IA.'
  }
};

export default landing;
